import { BiometricsRegisterDTO } from "@repo/core/services/entities/Biometrics";
import { AxiosInstance, AxiosResponse } from "axios";

const resourcePrefix = "/Biometria";

export class BiometricsResource {
  private apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async registerConsultation(
    data: BiometricsRegisterDTO
  ): Promise<AxiosResponse> {
    return this.apiProvider.post(`${resourcePrefix}/RegistrarConsulta`, data, {
      maxContentLength: Infinity,
      maxBodyLength: Infinity
    });
  }
}
